import { debounce } from '../../../node_modules/glo-shared-js/utils/helpers';

document.addEventListener('DOMContentLoaded', () => {
	var teacherSliderElement = document.querySelector('.teacher-slider');

	if (teacherSliderElement) {
		var setTeacherCardMargin = function() {
			var mainNavLogoRect = document.querySelector('.main-nav__logo').getBoundingClientRect();
			var leftOffset = window.innerWidth > 769 ? Math.round(mainNavLogoRect.left + window.scrollX) : 16;

			teacherSliderElement.querySelector('.teacher-card').style.marginLeft = leftOffset + 'px';
		};

		var toggleNavButtons = function() {
			var numCards = teacherSliderElement.querySelectorAll('.teacher-card').length;
			var hideNav = function() {
				teacherSliderElement.querySelector('.teacher-slider__nav-items').style.display = 'none';
			};

			switch (numCards) {
				case 4:
					if (window.innerWidth > 1120) hideNav();
					break;

				case 3:
					if (window.innerWidth > 840) hideNav();
					break;

				case 2:
					if (window.innerWidth > 565) hideNav();
					break;

				case 1:
					hideNav();
			}
		};

		var scrollTeacherSlider = debounce(function(e) {
			var scrollX = (window.innerWidth < 560) ? window.innerWidth : window.innerWidth / 2;
			var scrollLeft = (e.target.classList.contains('btn--next')) ? scrollX + teacherSliderElement.scrollLeft : -(scrollX - teacherSliderElement.scrollLeft);
			teacherSliderElement.scroll({
				left: scrollLeft,
				behavior: 'smooth'
			});
		}, 150);

		toggleNavButtons();
		setTeacherCardMargin();

		window.addEventListener('resize', debounce(function() {
			setTeacherCardMargin();
			toggleNavButtons();
		}, 150));

		teacherSliderElement.addEventListener('scroll', function() {
			if (teacherSliderElement.scrollLeft) {
				// If user has scrolled, show the 'previous' btn
				teacherSliderElement.querySelector('.btn--previous').style.display = 'flex';

				if ((teacherSliderElement.scrollLeft + teacherSliderElement.offsetWidth) === teacherSliderElement.scrollWidth) {
					// If user scrolled to the very end, hide the 'next' btn
					teacherSliderElement.querySelector('.btn--next').style.display = 'none';
				} else {
					// Otherwise, show the 'next' btn
					teacherSliderElement.querySelector('.btn--next').style.display = 'flex';
				}
			} else {
				// If user scrolled back to far left, hide the 'previous' btn
				teacherSliderElement.querySelector('.btn--previous').style.display = 'none';
			}
		});

		teacherSliderElement.querySelectorAll('.btn').forEach(function(buttonElement) {
			buttonElement.addEventListener('click', scrollTeacherSlider);
		});

		// Hide scrollbar, but maintain scrollability on FF
		if (navigator.userAgent.match(/firefox/i)) {
			teacherSliderElement.classList.add('teacher-slider--firefox');
		}
	}

	if (document.querySelector('.beginner-path')) {
		document.querySelector('.btn--select').addEventListener('change', function() {
			const intensityDescriptions = document.querySelectorAll('.beginner-path__intensity-description');
			const classesContainers = document.querySelectorAll('.beginner-path__classes-container');
			const thisIntensityDescription = document.querySelector(`.beginner-path__intensity-description--${this.value}`);
			const thisClassesContainer = document.querySelector(`.beginner-path__classes-container--${this.value}`);
			const elementsToShow = [thisIntensityDescription, thisClassesContainer];

			intensityDescriptions.forEach(function(el) {
				el.classList.add('hide');
			});

			classesContainers.forEach(function(el) {
				el.classList.add('hide');
			});

			elementsToShow.forEach(function(el) {
				el.classList.remove('hide');
			});
		});
	}
});
